import classNames from 'classnames/bind';

import usePriceCurrency from '../../PriceCurrencyProvider/usePriceCurrency';

import { InsightsPlans } from '../../../../data/pricingPlansData';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const InsightsPlansBox = (props) => {
  const { currency, currencySymbol, currencyShort } = usePriceCurrency();

  const { planType, isUserWithPlan, handleAddOnClick } = props;
  const priceSuffix = currency === 'gbp' ? 'Gbp' : '';
  const {
    title, iconLink,
    [`price${priceSuffix}`]: price,
    [`price1Month${priceSuffix}`]: price1Month,
    addons,
    [`price1Year${priceSuffix}`]: price1Year,
    [`price1YearByMonth${priceSuffix}`]: price1YearByMonth,
    [`price2Year${priceSuffix}`]: price2Year,
    [`price2YearByMonth${priceSuffix}`]: price2YearByMonth,
  } = InsightsPlans[planType];

  const setActivePlanType = (type) => {
    handleAddOnClick(addons[`uk_addons_${type}${currency === 'gbp' ? '_gbp' : ''}`]);
  };

  return (
    <div className={cx('insights-pricing-box', planType, { user_plan: isUserWithPlan })}>
      <div className={Styles['insights-pricing-box-title']}>
        {title}
      </div>
      <div className={Styles['insights-pricing-box-icon']}>
        <div className={Styles['insights-pricing-box-icon-holder']}>
          <img src={iconLink} alt="" />
        </div>
      </div>
      <div className={Styles['insights-pricing-box-price']}>
        +
        {currencySymbol}
        {price}
        {' '}
        <div className={Styles['insights-pricing-box-price-text']}>
          {currencyShort}
          /mo
        </div>
      </div>
      <div className={Styles['insights-pricing-box-contact']}>
        {planType === 'enterprises' ? (
          <>
            Plus Premium subscription. Multiple users?
            {' '}
            <a href="/contact-us">
              Contact Us
            </a>
          </>
        ) : (
          <>
            In addition to your chosen Premium subscription
          </>
        )}
      </div>
      <div className={Styles['insights-pricing-box-plans']}>
        <PricingBox
          title="1 month"
          subTitle=""
          priceMonth={price1Month}
          priceYear=""
          type="1month"
          setActivePlanType={setActivePlanType}
          currencySymbol={currencySymbol}
          currencyShort={currencyShort}
        />
        <PricingBox
          title="1 year"
          subTitle="2 months off!"
          priceMonth={price1YearByMonth}
          priceYear={price1Year}
          type="1year"
          setActivePlanType={setActivePlanType}
          currencySymbol={currencySymbol}
          currencyShort={currencyShort}
        />
        <PricingBox
          title="2 years"
          subTitle="6 months off!"
          priceMonth={price2YearByMonth}
          priceYear={price2Year}
          type="2year"
          setActivePlanType={setActivePlanType}
          currencySymbol={currencySymbol}
          currencyShort={currencyShort}
        />
      </div>
    </div>
  );
};

const PricingBox = ({
  title, subTitle, priceMonth, priceYear, type,
  setActivePlanType, currencySymbol, currencyShort,
}) => (
  <div
    className={cx('insights-pricing-box-plan')}
    onClick={() => setActivePlanType(type)}
  >
    <div className={Styles['insights-pricing-box-plan-holder-title']}>
      <div className={Styles['insights-pricing-box-plan-title']}>
        {title}
      </div>
      <div className={Styles['insights-pricing-box-plan-sub-title']}>
        {subTitle}
      </div>
    </div>
    <div className={Styles['insights-pricing-box-plan-holder']}>
      <div className={Styles['insights-pricing-box-plan-month']}>
        +
        {currencySymbol}
        {priceMonth}
        {' '}
        {currencyShort}
        /month
      </div>
      <div className={Styles['insights-pricing-box-plan-year']}>
        {priceYear && (
          <>
            {currencySymbol}
            {priceYear}
            {' '}
            {currencyShort}
            /year
          </>
        )}
      </div>
    </div>
  </div>
);

export default InsightsPlansBox;
